function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M211,0c-33.084,0-60,26.916-60,60s26.916,60,60,60s60-26.916,60-60S244.084,0,211,0z M211,90c-16.542,0-30-13.458-30-30 s13.458-30,30-30s30,13.458,30,30S227.542,90,211,90z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M407,0c-57.897,0-105,47.103-105,105s47.103,105,105,105c57.897,0,105-47.103,105-105C512,47.103,464.897,0,407,0z  M407,180c-41.355,0-75-33.645-75-75s33.645-75,75-75c41.355,0,75,33.645,75,75S448.355,180,407,180z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M437,90h-15V75c0-8.284-6.716-15-15-15s-15,6.716-15,15v30c0,8.284,6.716,15,15,15h30c8.284,0,15-6.716,15-15 S445.284,90,437,90z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M347,271h-76v-91c0-33.084-26.916-60-60-60s-60,26.916-60,60v136c0,5.258,0.915,10.307,2.58,15.001h-39.089 c0,0-15.972-127.732-24.502-197.011C89.45,109.641,69.476,90,45,90c-24.813,0-45,20.187-45,45c0,0.619,0.039,1.238,0.115,1.853 l29.896,240.169C30.44,396.134,42.846,412.339,60,418.423V497c0,8.284,6.716,15,15,15s15-6.716,15-15v-76h121v76 c0,8.284,6.716,15,15,15s15-6.716,15-15v-78.58c17.459-6.192,30-22.865,30-42.42c0-5.258-0.915-10.305-2.58-15H302v106 c0,24.813,20.187,45,45,45s45-20.187,45-45V316C392,291.187,371.813,271,347,271z M226,391H75c-8.271,0-15-6.729-15-15 c0-1.403,1.63,12.164-29.98-241.772C30.423,126.314,36.988,120,45,120c8.271,0,15,6.729,15,15 c0,1.87,26.365,212.858,26.365,212.858C87.304,355.365,93.685,361,101.25,361c5.932,0,117.936,0,124.75,0c8.271,0,15,6.729,15,15 S234.271,391,226,391z M362,467c0,8.271-6.729,15-15,15s-15-6.729-15-15V346c0-8.284-6.716-15-15-15c-4.283,0-114.149,0-121.01,0 c-8.267-0.006-14.99-6.732-14.99-15V180c0-16.542,13.458-30,30-30s30,13.458,30,30v106c0,8.284,6.716,15,15,15h91 c8.271,0,15,6.729,15,15V467z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

const SvgWaitingRoom = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaitingRoom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waiting_room.ade542ab.svg";
export { ForwardRef as ReactComponent };